import { jsx as _jsx } from "react/jsx-runtime";
import { TextField as MuiTextField, } from "@mui/material";
import { debounce } from "lodash-es";
import React from "react";
import { useLatest } from "react-use";
export const FormattedInput = ({ id, label, placeholder, autoCompleteDisabled = true, value, getFormattedValue, getActualValue, getEditableValue, debounceMs = 500, onChange, helperText, ...props }) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const [dirtyValue, setDirtyValue] = React.useState(getEditableValue(value));
    const [error, setError] = React.useState();
    const latestChangeHandler = useLatest((value) => {
        try {
            setError(undefined);
            const actualValue = getActualValue(value);
            onChange(actualValue);
        }
        catch (error) {
            if (error instanceof Error) {
                setError(error.message);
            }
        }
    });
    const debouncedHandleChange = React.useMemo(() => debounce((value) => {
        latestChangeHandler.current(value);
    }, debounceMs), [debounceMs, latestChangeHandler]);
    function getValue(value) {
        return isFocused ? dirtyValue : getFormattedValue(value);
    }
    return (_jsx(MuiTextField, { ...props, id: id, type: "text", label: label, placeholder: placeholder, value: getValue(value), autoComplete: autoCompleteDisabled ? "off" : undefined, onChange: (event) => {
            const dirtyValue = event.target.value;
            setDirtyValue(dirtyValue);
            debouncedHandleChange(dirtyValue);
        }, onFocus: () => {
            setDirtyValue(getEditableValue(value));
            setIsFocused(true);
        }, onBlur: (event) => {
            setIsFocused(false);
            if (props.onBlur) {
                props.onBlur(event);
            }
        }, error: !!error, helperText: error ?? helperText, style: props.style }));
};
//# sourceMappingURL=FormattedInput.js.map